import React  from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import Jibber from '/app/src/jibber'
import {Flex, SVGButton, TextInput} from '/app/src/component'

import style from './style.css'

const ListItemStyle = {
    width: '300px',
    height: '35px',
    borderRadius: '200px',
    vAlignContent: 'center',
    fontSize: '20px',
    paddingLeft: '20px',
    position: 'relative',
    cursor: 'pointer',
    backgroundHover: 'mediumgrey',
    backgroundColor: 'darkwhite',
    hover: 'black',
}

const VisibleIconStyle = (visible, parentVisible) => ({
    color: visible && parentVisible?'blue':'lightgrey',
    src:visible?'/images/Visible.svg':'/images/Hidden_M.svg',
    marginLeft: '20px'
})

const ButtonStyle = {
    color: 'lightblack',
    hover: 'blue'

}
// EDIT
const AddNewOptionInputStyle = {
    dataName: 'EditOptionInput',
    width: '300px',
    borderRadius: '200px',
    fontSize: '24px',
    vAlignContent: 'center',
    color: 'black',
    position: 'relative'
}

const TextInputStyle = {
    border: '3px solid',
    borderRadius: '200px',
    color: 'blue',
    height: '37px',
    autoComplete: 'off'
}
const TextInputSaveButtonStyle = {
    color: 'darkgrey',
    borderRadius: '200px',
    src: '/images/Choose-Next_M.svg',
    position: 'absolute',
    right: '10px',
    hover: 'blue',
    backgroundHover: 'transparent'
}

export default class SubItem extends Jibber {
    constructor(props){
        super(props)
        this.useState({
            hover: false,
            view: 'button',
        })

        this.editView = this.editView.bind(this)
    }

    editView(){
        const {setView} = this
        const {item} = this.props

        const _handleKeys = (e) => {
            if (['Enter', 'Escape'].includes(e.key)){
                setView('button')
            }
        }

        const TextInputProps = {
            value: item.label,
            onChange: (e)=>this.props.onUpdate(this.props.parentId, e.target.value, item.visible, item.id),
            onKeyDown: _handleKeys,
            maxLength: 30,
            autoFocus: true,
        }

        return (
            <OutsideClickHandler
                onOutsideClick={()=>{_handleKeys({key: 'Escape'})}}
            >

            <Flex {...AddNewOptionInputStyle}>
                <TextInput
                    {...TextInputProps}
                    className={style.InnerTextInput}
                    {...TextInputStyle}
                />
            <SVGButton {...TextInputSaveButtonStyle} onClick={()=>this.setView('button')}/>
            </Flex>
            </OutsideClickHandler>
        )
    }
    buttonView(){
        const {item, onDelete, parentVisible} = this.props
        const {hover} = this.state
        const {setHover, setView} = this
        return (
            <Flex {...ListItemStyle} onMouseEnter={()=>{setHover(true)}} onMouseLeave={()=>{setHover(false)}}
                color={item.visible && parentVisible?'black':'darkgrey'}
                >
                <Flex marginRight='auto'>
                    <div className='ellipsis'>
                        {item.label}
                    </div>
                </Flex>
                <Flex width='80px' shrink={0} grow={0}>
                {hover && (
                    <React.Fragment>
                    <SVGButton src='/images/Trash.svg' {...ButtonStyle} onClick={()=>{onDelete(item.id)}} w='40px' hover='NegativeRed'/>
                    <SVGButton src='/images/Edit.svg' {...ButtonStyle} onClick={()=>{setView('edit')}} w='40px'/>
                    </React.Fragment>
                    )
                }
                </Flex>
            </Flex>
        )
    }


    render(){
        const {item, parentId, parentVisible, onUpdate} = this.props
        const {view} = this.state
        return(
            <Flex column shrink={0}>
                <Flex height='35px' vAligncontent='center' hAlignContent='right' marginBottom='5px'>
                    {view === 'button' && this.buttonView()}
                    {view === 'edit' && this.editView()}
                    <SVGButton {...VisibleIconStyle(item.visible, parentVisible)} onClick={()=>{
                        this.setView('button');
                        onUpdate(parentId, item.label, !item.visible, item.id)
                    }}
                    />
                </Flex>
            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Exchange/_SubItem.js